<template>
  <div class="mt-4">
    <v-card class="mx-auto" max-width="95%" elevation="2">
      <v-toolbar dark>
        <v-toolbar-title>프롬북 · 공지사항 관리</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-chip small outlined dark class="mr-2">총 {{ total.toLocaleString() }}건</v-chip>
        <v-btn small outlined dark @click="goWrite">
          <v-icon left small>mdi-plus</v-icon>새 공지
        </v-btn>
      </v-toolbar>

      <!-- 공지 리스트 -->
      <v-card-text class="pa-0 pt-2">
        <div style="overflow-x: auto;">
          <v-data-table
            :headers="headers"
            :items="list"
            :items-per-page="50"
            :footer-props="{'items-per-page-options':[50, 100, 200]}"
            :loading="loading"
            :server-items-length="total"
            class="elevation-0"
          >
            <template v-slot:item.notice_type="{ item }">
              <v-chip x-small :color="item.notice_type === 'hidden' ? 'grey' : 'blue lighten-4'">
                {{ item.notice_type === 'hidden' ? '숨김' : '일반' }}
              </v-chip>
            </template>
            <template v-slot:item.is_enabled="{ item }">
              <v-chip x-small :color="item.is_enabled ? 'green' : 'grey'" dark>
                {{ item.is_enabled ? '활성' : '비활성' }}
              </v-chip>
            </template>
            <template v-slot:item.created_at="{ item }">
              {{ formatDate(item.created_at) }}
            </template>
            <template v-slot:item.actions="{ item }">
              <v-btn icon small @click="goEdit(item)" title="수정">
                <v-icon small>mdi-pencil</v-icon>
              </v-btn>
              <v-btn icon small @click="deleteNotice(item)" title="삭제">
                <v-icon small color="red">mdi-delete</v-icon>
              </v-btn>
            </template>
          </v-data-table>
        </div>
        <v-container v-if="!loading && list.length === 0" class="text-center py-8">
          <v-icon size="56" color="grey lighten-1">mdi-bell-off</v-icon>
          <p class="text-body-1 grey--text mt-3">공지사항이 없습니다.</p>
        </v-container>
      </v-card-text>
    </v-card>

    <div class="py-12"></div>
  </div>
</template>

<script>
import { prombook } from '../../api'

export default {
  name: 'Prombook_NoticeList',
  data() {
    return {
      loading: false,
      total: 0,
      list: [],
      page: 1,
      page_size: 50,
      headers: [
        { text: 'ID', value: 'id', width: '80px' },
        { text: '제목', value: 'title' },
        { text: '타입', value: 'notice_type', width: '90px' },
        { text: '활성', value: 'is_enabled', width: '90px' },
        { text: '작성자', value: 'created_by', width: '120px' },
        { text: '조회수', value: 'view_count', width: '90px' },
        { text: '작성일', value: 'created_at', width: '160px' },
        { text: '액션', value: 'actions', width: '100px', sortable: false },
      ],
    }
  },
  methods: {
    formatDate(v) {
      if (!v) return ''
      return String(v).replace('T', ' ').slice(0, 16)
    },
    async load() {
      try {
        this.loading = true
        const r = await prombook.list_notice(this.page, this.page_size)
        this.list = (r && r.notice_list) ? r.notice_list : []
        this.total = (r && r.total) ? r.total : 0
      } catch (e) {
        console.error(e)
      } finally {
        this.loading = false
      }
    },
    goWrite() {
      this.$router.push('/prombook/notice/write')
    },
    goEdit(item) {
      this.$router.push(`/prombook/notice/write/${item.id}`)
    },
    async deleteNotice(item) {
      if (!confirm(`공지 [${item.title}]을 삭제하시겠습니까?`)) return
      try {
        await prombook.delete_notice(item.id)
        alert('삭제되었습니다.')
        this.load()
      } catch (e) {
        console.error(e)
        alert('삭제에 실패했습니다.')
      }
    },
  },
  mounted() {
    this.load()
  },
}
</script>
